import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase } from 'lucide-react';
const experiences = [{
  period: 'Jan 2025 — Present',
  role: 'Technology Support III (Associate)',
  company: 'JP Morgan Chase & Co',
  description: 'Managing nightly automation jobs, maintaining Groovy + Cucumber frameworks, and leading QA initiatives.'
}, {
  period: 'Jun 2022 — Jan 2025',
  role: 'Test Specialist',
  company: 'IBM India Pvt. Ltd',
  description: 'Developed comprehensive test scenarios, executed tests, and contributed to regression automation.'
}, {
  period: 'Dec 2017 — Jun 2022',
  role: 'Software Products & Platform Engineering',
  company: 'Accenture Solutions',
  description: 'Translated requirements into test cases and developed Java + Selenium automation scripts.'
}];
export function CareerSection() {
  return <section id="career" className="py-24 px-6 bg-white" data-id="element-12">
      <div className="max-w-3xl mx-auto" data-id="element-13">
        <div className="flex items-center gap-4 mb-12" data-id="element-14">
          <div className="p-3 bg-zen-accent/10 rounded-full text-zen-accent" data-id="element-15">
            <Briefcase size={24} data-id="element-16" />
          </div>
          <h2 className="text-5xl font-moon-dance text-zen-text" data-id="element-17">
            My Career, in brief
          </h2>
        </div>

        <div className="relative border-l border-zen-text/10 ml-6 space-y-12" data-id="element-18">
          {experiences.map((exp, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative pl-12" data-id="element-19">
              {/* Timeline Dot */}
              <div className="absolute -left-[5px] top-2 w-2.5 h-2.5 rounded-full bg-zen-bg border-2 border-zen-accent" data-id="element-20" />

              <div className="group hover:bg-zen-bg p-6 rounded-2xl transition-colors duration-300 -mt-4" data-id="element-21">
                <span className="inline-block px-3 py-1 bg-zen-text text-white text-xs font-bold tracking-wider rounded-full mb-3" data-id="element-22">
                  {exp.period}
                </span>
                <h3 className="text-2xl font-bold text-zen-text mb-1" data-id="element-23">
                  {exp.role}
                </h3>
                <p className="text-zen-accent font-medium mb-3" data-id="element-24">
                  {exp.company}
                </p>
                <p className="text-zen-text/60 leading-relaxed" data-id="element-25">
                  {exp.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}